import { setInStorage, STORAGE_TYPE } from '@Service/storageService';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import {
    StripLeadingSectionNumbering,
    StripLeadingNonAlphaNumericChars,
    StripLeadingBulletNumbering,
    StripLeadingCaptializedSubtitles,
    TidyUpSentenceEndings,
    TerminateAddCarriageReturn
} from '@Utils/parsingUtils';
import { NOTIFICATION_HANDLER } from '@Constants/types';
import store from '@Store';

export function clearSubmissionIDs() {
    setInStorage('sealAtnDocumentId', null, STORAGE_TYPE.PROPERTY_BAG);
    setInStorage('sealAtnDocumentStatus', null, STORAGE_TYPE.PROPERTY_BAG);
    setInStorage('digAppId', null, STORAGE_TYPE.PROPERTY_BAG);
    setInStorage('digAppName', null, STORAGE_TYPE.PROPERTY_BAG);
}

export function useOriginalValue(valueItem) {
    try {
        let originalValue = valueItem.value;
        valueItem.attributes.forEach(item => {
            if (item.name === 'originalValue') {
                originalValue = item.value;
            }
        });
        return originalValue;
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'documentActions.useOriginalValue', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
        return null;
    }
}

export function cleanMetadataValue(valueItem) {
    try {
        let parsedValue = valueItem;
        if (parsedValue) {
            parsedValue = StripLeadingNonAlphaNumericChars(parsedValue);
            parsedValue = StripLeadingSectionNumbering(parsedValue);
            parsedValue = StripLeadingBulletNumbering(parsedValue);
            parsedValue = StripLeadingCaptializedSubtitles(parsedValue);
            parsedValue = StripLeadingSectionNumbering(parsedValue);
            parsedValue = StripLeadingBulletNumbering(parsedValue);
            parsedValue = TidyUpSentenceEndings(parsedValue);
            parsedValue = TerminateAddCarriageReturn(parsedValue);
        }
        return parsedValue;
    } catch (err) {
        addLog(LOG_TYPE.ERROR, 'documentActions.cleanMetadataValue', err);
        store.dispatch({
            type: NOTIFICATION_HANDLER.ERROR,
            payload: err
        });
        return valueItem;
    }
}
